const _excluded = ["setEnabled"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { useGetAllPaginatedData, CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import { useCurrentProjectId } from './CurrentProjectIdContext';
import { removeOldDuplicatesBy } from './helpers/removeOldDuplicatesBy';
import useClientSideDataModification from './hooks/useClientSideDataModification';
/**
 * Context for roles list.
 */
const RolesContext = getOrCreateGlobalContext(CONTEXT_NAMES.RolesContext);
const useRolesContext = () => useContextWithValidation(RolesContext, {
  hook: 'useRoles',
  provider: 'RolesProvider'
});
export const useRoles = () => {
  const _useRolesContext = useRolesContext(),
    {
      setEnabled
    } = _useRolesContext,
    rest = _objectWithoutProperties(_useRolesContext, _excluded);
  useEffect(() => {
    if (setEnabled) {
      setEnabled(true);
    }
  }, [setEnabled]);
  return rest;
};
const PAGE_LIMIT = 200;
export const RolesProvider = _ref => {
  let {
    children
  } = _ref;
  const [enabled, setEnabled] = useState(false);
  const projectId = useCurrentProjectId();
  const adminApiUrl = getAdminApiUrl();
  const url = enabled && projectId ? "".concat(adminApiUrl, "/v1/projects/").concat(projectId, "/roles?limit=").concat(PAGE_LIMIT) : '';
  const {
    loading: loadingData,
    error,
    data: dataFromBE,
    retry,
    clearSessionStorage
  } = useGetAllPaginatedData({
    url
  });
  const rolesFromBE = useMemo(() => {
    return dataFromBE && removeOldDuplicatesBy(dataFromBE.flatMap(page => page.results), item => item.id);
  }, [dataFromBE]);
  const {
    modifyData,
    addData: addRoles,
    updateEntity: updateRole,
    removeEntityById: removeRoleById
  } = useClientSideDataModification(clearSessionStorage);
  const loading = loadingData || !enabled;
  const data = useMemo(() => modifyData(rolesFromBE), [modifyData, rolesFromBE]);
  const value = useMemo(() => ({
    data,
    loading,
    error,
    retry,
    addRoles,
    updateRole,
    removeRoleById,
    setEnabled: enabled ? undefined : setEnabled
  }), [addRoles, updateRole, data, error, loading, removeRoleById, retry, enabled]);
  return /*#__PURE__*/React.createElement(RolesContext.Provider, {
    value: value
  }, children);
};
RolesProvider.displayName = 'RolesProvider';
RolesProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=RolesContext.js.map